import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment, endpoints } from '@environment';
import {
  AssetAccount,
  CreateAssetAccountRequest,
  PagedRequest,
  PagedResponse,
  UpdateAssetAccountRequest,
} from '@core/models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AssetService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/${endpoints.v1.assets}`;

  getAll(includeArchived = false): Observable<AssetAccount[]> {
    const params = new HttpParams().set('includeArchived', includeArchived);
    return this.http.get<AssetAccount[]>(this.baseUrl, { params });
  }

  getPaged(
    request: PagedRequest,
    includeArchived = false
  ): Observable<PagedResponse<AssetAccount>> {
    const params = new HttpParams().set('includeArchived', includeArchived);
    return this.http.post<PagedResponse<AssetAccount>>(
      `${this.baseUrl}/paged`,
      request,
      { params }
    );
  }

  getById(id: string): Observable<AssetAccount> {
    return this.http.get<AssetAccount>(`${this.baseUrl}/${id}`);
  }

  create(payload: CreateAssetAccountRequest): Observable<AssetAccount> {
    return this.http.post<AssetAccount>(this.baseUrl, payload);
  }

  update(
    id: string,
    payload: UpdateAssetAccountRequest
  ): Observable<AssetAccount> {
    return this.http.put<AssetAccount>(`${this.baseUrl}/${id}`, payload);
  }

  archive(id: string): Observable<AssetAccount> {
    return this.http.post<AssetAccount>(`${this.baseUrl}/${id}/archive`, null);
  }

  restore(id: string): Observable<AssetAccount> {
    return this.http.post<AssetAccount>(`${this.baseUrl}/${id}/restore`, null);
  }
}
